import { css, ThemeProvider } from "@emotion/react";
import { type GridSlotProps } from "@mui/x-data-grid-premium";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import { DataGridOverlay } from "./DataGridOverlay.tsx";
import NoResultsIllustration from "src/assets/illustrations/database_viewed_through_lupe.svg?react";
import { H4 } from "src/components/HeadingV2/HeadingV2.tsx";

import { useGridPrivateApiContext } from "@mui/x-data-grid-premium/hooks/utils/useGridPrivateApiContext";

export const DataGridNoResultsOverlay = (
  props: GridSlotProps["noResultsOverlay"],
) => {
  const theme = useNonConflictingTheme();

  const apiRef = useGridPrivateApiContext();

  const title = apiRef.current.getLocaleText("noResultsOverlayLabel");

  return (
    <ThemeProvider theme={theme}>
      <DataGridOverlay>
        <H4 css={styles.title}>{title}</H4>
        <NoResultsIllustration css={styles.image} />
      </DataGridOverlay>
    </ThemeProvider>
  );
};

const styles = {
  image: (theme: ExactTheme) =>
    css({
      color: theme.colorsV2.grey[600],
      "@media (max-height: 400px)": {
        display: "none",
      },
    }),
  title: css({
    textAlign: "center",
  }),
};
